export default Object.freeze({
  HOME: {
    name: 'Home',
    route: '/'
  },
  FIVES: {
    name: 'Fives',
    route: '/fives'
  },
  ERROR: {
    name: 'Error',
    route: '/error'
  },
  BONUS: {
    name: 'Bonus',
    route: '/bonus'
  },
  BONUS_DETAILS: {
    name: 'Bonus Details',
    route: '/bonus/:bonusType'
  },
  DECISION_TIME: {
    name: 'Decision Time',
    route: '/bonus/:bonusType/action'
  },
  WIDGET: {
    name: 'Widget',
    route: '/widget'
  }
});
